import { render } from "./CreateServiceView.vue?vue&type=template&id=22c742d8"
import script from "./CreateServiceView.vue?vue&type=script&lang=js"
export * from "./CreateServiceView.vue?vue&type=script&lang=js"

import "./CreateServiceView.vue?vue&type=style&index=0&id=22c742d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__